import { GET_ALERTS, GET_ALERTS_SUCCESS, GET_ALERTS_FAIL } from "./actionTypes";

const INIT_STATE = {
  error: {},
  alerts: [],
  loadingAlerts: false,
};

const alerts = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_ALERTS:
      return {
        ...state,
        loadingAlerts: true,
      };
    case GET_ALERTS_SUCCESS:
      return {
        ...state,
        loadingAlerts: false,
        alerts: action.payload,
      };
    case GET_ALERTS_FAIL:
      return {
        ...state,
        loadingAlerts: false,
      };
    default:
      return state;
  }
};

export default alerts;
